import { Button } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import { OrderMealType } from 'models/order.model';

type OrderNoteModalProps = {
  show: boolean;
  onClose: () => void;
  handleClick: (note: string) => void;
  orderMeal: OrderMealType;
};

const OrderNoteModal: FC<OrderNoteModalProps> = ({ show, onClose, handleClick, orderMeal }) => {
  const [note, setNote] = useState(orderMeal.order_note ?? '');
  const handleClose = () => {
    handleClick(note);
    onClose();
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Order note'
      contentClassName='sm:!max-w-[400px]'>
      <div>
        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
            <p className='text-[#2E3031]'>Add note</p>
          </div>
          <LocalTextArea
            placeholder='e.g add more pepper'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[135px] placeholder:text-[#B5B8BA]'
            value={note}
            onChange={(e) => setNote(e.target.value)}
            autoFocus
          />
        </div>
        <div className='mt-5 flex justify-end'>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            disabled={note.length === 0}
            onClick={handleClose}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default OrderNoteModal;
